import CharityView from './CharityView';

export default CharityView;
